import { Route, Routes } from 'react-router';
import { observer } from 'mobx-react-lite';
import { CircularProgress } from '@mui/material';

import { useMount, useUnmount } from '@cutwise/utils';

import AppErrorMessage from '@/dmdrive/core/components/AppErrorMessage/AppErrorMessage';
import Header from '@/dmdrive/core/components/Header/Header';
import { PAGE_MAIN } from '@/dmdrive/core/constants/pages';
import { PAGE_TOPIC } from '@/dmdrive/drive/constants/pages';
import ProjectPage from '@/dmdrive/drive/pages/ProjectPage/ProjectPage';
import ProjectsListPage from '@/dmdrive/drive/pages/ProjectsListPage/ProjectsListPage';
import { useStore } from '@/dmdrive/store';

import { AppContent, AppRoot, LoaderWrapper } from './App.styles';

function App() {
  const { isReady, dispose, error, initApp } = useStore('appStore');

  useMount(initApp);

  useUnmount(dispose);

  if (error) {
    return <AppErrorMessage error={error} />;
  }

  if (!isReady) {
    return (
      <LoaderWrapper>
        <CircularProgress />
      </LoaderWrapper>
    );
  }

  return (
    <AppRoot>
      <Header />

      <AppContent>
        <Routes>
          <Route path={PAGE_MAIN} element={<ProjectsListPage />} />

          <Route path={`${PAGE_TOPIC}/:conferenceId`} element={<ProjectPage />} />
        </Routes>
      </AppContent>
    </AppRoot>
  );
}

export default observer(App);
